var React = require('react');

function CheckboxBorder (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"default","fill":"none","fillRule":"evenodd","stroke":"currentColor","strokeWidth":"2","d":"M24.9 18.03v6.46c0 2.32-1.84 4.2-4.13 4.2H6.14A4.17 4.17 0 0 1 2 24.5V9.64c0-2.32 1.85-4.2 4.14-4.2H24.9v12.6z","key":0}),React.createElement("path",{"className":"selected","stroke":"currentColor","strokeWidth":"2","fill":"none","d":"M24.9 16v8.5c0 2.31-1.84 4.2-4.13 4.2H6.14A4.17 4.17 0 0 1 2 24.5V9.63c0-2.32 1.85-4.2 4.14-4.2h14.63","key":1})]);
}

CheckboxBorder.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = CheckboxBorder;

CheckboxBorder.default = CheckboxBorder;
